export default __webpack_public_path__ + "static/media/news_bg.14e12599.jpg";